import React from 'react';
import { observer } from 'mobx-react-lite';
import { ImagesGrid } from 'polotno/side-panel/images-grid';
import { SectionTab } from 'polotno/side-panel';
import { Button } from '@blueprintjs/core';

import * as api from '../api';

export const MyArtboardsPanel = observer(({ store }) => {
  const [items, setItems] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);

  async function load() {
    setIsLoading(true);
    try {
      const items = await api.loadArtboards();
      setItems(items);
    } catch (e) {}

    setIsLoading(false);
  }

  React.useEffect(() => {
    load();

    window.addEventListener('artboardSaved', load);
    return () => {
      window.removeEventListener('artboardSaved', load);
    };
  }, []);

  return (
    <div style={{ height: '100%', overflow: 'auto' }}>
      <ImagesGrid
        images={items}
        getPreview={(item) => item.preview}
        onSelect={async (item, pos, element) => {
          store.loadJSON(item.artboardJson);
        }}
        rowsNumber={2}
        isLoading={isLoading}
        loadMore={false}
        getCredit={(item) => {
          return (
            <div>
              <Button
                icon="trash"
                onClick={async (e) => {
                  e.stopPropagation();
                  if (
                    window.confirm(
                      'Are you sure you want to delete this artboard?'
                    )
                  ) {
                    await api.deleteArtboard(item.id);
                    setItems(items.filter((i) => i.id !== item.id));
                    load();
                  }
                }}
              ></Button>
            </div>
          );
        }}
      />
    </div>
  );
});

export const MyArtboardsSection = {
  name: 'My Artboards',
  Tab: (props) => (
    <SectionTab name="My Artboards" {...props}>
      <img
        src={process.env.PUBLIC_URL + '/icons/my-artboards.svg'}
        alt="My Artboards"
        style={{ width: '25px' }}
      />
    </SectionTab>
  ),
  Panel: MyArtboardsPanel,
};
